import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { OfferBlock } from '../OfferBlock';
const includedRows = [{
  title: '🗺️ GLP-1 Decision Map™ — 6 premium clinical volumes',
  value: '$97'
}, {
  title: '🎁 5 exclusive bonuses',
  value: '$197'
}];
const perks = ['One-time payment', 'Lifetime access', 'No monthly fees', 'Instant download'];
export function Offer() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-192" data-mp="3a5yrtz5ha14e">
      <div className="mx-auto max-w-3xl" data-id="element-193" data-mp="3a3cjvyeodjln">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-teal-600" data-id="element-194" data-mp="3f40cupmgsaii">
          🏆 Special launch offer
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-195" data-mp="3jxcycqvuk171">
          Here's everything you'll <em className="italic text-teal-600" data-id="element-196" data-mp="3swggnsn6wckh">receive today</em>
        </h2>

        <div className="mt-9 overflow-hidden rounded-3xl border-2 border-navy-800 bg-cream" data-id="element-197" data-mp="1pn7a1i8t74v">
          <ul className="divide-y divide-navy-100" data-id="element-198" data-mp="1nau01nfjky5">
            {includedRows.map(row => <li key={row.title} className="flex items-center justify-between gap-4 px-5 py-4 sm:px-7" data-id="element-199" data-mp="1kj3wpnunb3xu">
                <span className="text-[14px] font-semibold leading-snug text-navy-800 sm:text-base" data-id="element-200" data-mp="1bks7nq9fge7i">
                  {row.title}
                </span>
                <span className="shrink-0 text-[14px] font-bold text-navy-700/60 line-through sm:text-base" data-id="element-201" data-mp="16n0deplb8g05">
                  {row.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-4 bg-navy-50 px-5 py-4 sm:px-7" data-id="element-202" data-mp="1zbnv6b6uon8y">
              <span className="text-[13px] font-extrabold uppercase tracking-wide text-navy-800" data-id="element-203" data-mp="1uicwwyg3tesn">
                Total value
              </span>
              <span className="font-display text-2xl font-bold text-navy-700/60 line-through" data-id="element-204" data-mp="2mzyp0ue4pmnq">
                $294
              </span>
            </li>
          </ul>

          <div className="bg-navy-800 px-5 py-8 text-center sm:px-7 sm:py-10" data-id="element-205" data-mp="2i7xhflrwok41">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-teal-100" data-id="element-206" data-mp="316s8o6msorlo">
              Today, get complete access for just
            </p>
            <p className="mt-2 font-display text-[64px] font-bold leading-none text-white sm:text-7xl" data-id="element-207" data-mp="2sdf60cyxibme">
              $27
            </p>
            <p className="mt-2 inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5 text-[12px] font-semibold text-white/85" data-id="element-208" data-mp="2wdfw4uve4b9a">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-209" data-mp="2ihc3v742uczg" />
              Currency conversion is automatic in your country
            </p>

            <ul className="mx-auto mt-6 grid max-w-md grid-cols-2 gap-2.5" data-id="element-210" data-mp="29fco0i4stey3">
              {perks.map(perk => <li key={perk} className="flex items-center gap-2 rounded-xl bg-white/[0.07] px-3 py-2.5 text-left" data-id="element-211" data-mp="2dgepz6q3o53r">
                  <CheckIcon className="h-4 w-4 shrink-0 text-teal-100" aria-hidden="true" data-id="element-212" data-mp="botbaynb380q" />
                  <span className="text-[12px] font-semibold leading-snug text-white/90 sm:text-[13px]" data-id="element-213" data-mp="1w62d6516zfc9">
                    {perk}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-7 max-w-2xl text-center text-[15px] leading-relaxed text-navy-700/85 sm:text-base" data-id="element-214" data-mp="25xydznunxjk6">
          For less than the cost of a typical consultation, you'll have a visual system you can use
          as a reference whenever you need to organize a GLP-1 consultation.
        </p>

        <div className="mt-8" data-id="element-215" data-mp="2av70g0mug9r8">
          <OfferBlock label="Get the GLP-1 Decision Map™" note="One-time payment of $27 · Automatic currency conversion · Instant download · Lifetime access · 7-day guarantee" data-id="element-216" data-mp="2ov9grifi6v4d" />
        </div>
      </div>
    </section>;
}